export default __webpack_public_path__ + "static/media/item-drop.c815c8e0.png";